import { Button, Col, DatePicker, Form, Input, InputNumber, Modal, Row, Select, Space } from 'antd';
import React, { useEffect, useState } from 'react';
import EventEmitter from '../utils/eventEmitter';
import { Badge } from 'flowbite-react';
import Axois from '../utils/axios';
import dayjs from 'dayjs';



const MyFooter = ({ handleSell, handleCancel }) => {
  return (
    <div className='flex border-t-2 pt-2'>
      <Button className='me-3' onClick={handleSell} type='primary'>SAVE</Button>
      <Button onClick={handleCancel} danger>CANCEL</Button>
    </div>
  )
};


const LockDateModal = ({ success }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();
  const [lockDates, setLockDates] = useState({});


  const handleCancel = () => {
    setIsModalOpen(false);
    // form.resetFields();
    // form.
  }
  
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const saveDates = async() => {
    try {
      let data = form.getFieldsValue();
      let lockdates = [];
      Object.entries(data).forEach(arr => {
        let obj = {name: arr[0], value: arr[0].includes('date') ? new Date(arr[1]).toLocaleDateString() : arr[1]};
        lockdates.push(obj);
      });
      console.log(lockdates);
      const response = await Axois.patch('/settings/lockdatesettings', lockdates);
      const responseData = await response.data;
      success(responseData.message);
    }catch (err) {
      console.log(err);
    }
  }
 
  useEffect(() => {
    EventEmitter.subscribe('open_lock_date', data => setIsModalOpen(data));

    return () => EventEmitter.unsubscribe('open_lock_date');
  },[]) 
   
  useEffect(() => {
    Axois.get('settings/lockdatesettings/lockdate')
    .then(res => {
      let data = res.data.reduce((obj, item) => Object.assign(obj, { [item.name]: dayjs(new Date(item.value).toISOString(), 'YYYY-MM-DD')}), {});
      form.setFieldsValue(data);
    })
    .catch(err => console.log(err))
  },[])



  return (
    <Modal title="Lock Dates" width={900} open={isModalOpen} onOk={handleOk} onCancel={handleCancel} footer={<MyFooter handleCancel={handleCancel} handleSell={saveDates}/>}>
      <Form
        form={form}
        className='border-t-2 py-5' 
        labelAlign='left'
        labelCol={{span: 11}}
        initialValues={{ }}
        autoComplete="off"
        variant='borderless'
      >
        <Row className=''>
          <Col md={{span: 11}}>
            <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">MANAGEMENT CLOSING</Badge>
            <Badge className="text-slate-300 text-md italic bg-transparent mb-3">Lock specific journal entries</Badge>
            <Form.Item label='Journal Entries Lock Date' name={'lockdate.entries_lock_date'} className='font-semibold mb-2' required>
              <DatePicker className='w-full font-normal' />
            </Form.Item>
            <Form.Item label='Tax Return Date' name={'lockdate.tax_return_date'} className='font-semibold mb-2' required>
              <DatePicker className='w-full font-normal' />
            </Form.Item>
          </Col>
          <Col md={{span: 11, offset:1}}>
            <Badge className="text-slate-500 text-md bg-transparent	border-b-2 mb-3">ACCOUNTING PERIOD CLOSING</Badge>
            <Badge className="text-slate-300 text-md italic bg-transparent mb-3">Lock all journal entries</Badge>
            <Form.Item label='All Users Lock Date' name={'lockdate.all_users_lock_date'} className='font-semibold mb-2' required >
              <DatePicker className='w-full font-normal'/>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

export default LockDateModal;